import { Grid } from '@mui/material';
import { CerebroStyledBox, CerebroText } from '../../../shared/components';
import { CurrentUser, DataRoom, DealPartnerContact, UnlockUser } from '../../../shared/models';
import { DataRoomPartnerContactItem } from './DataRoomPartnerContactItem';

interface DataRoomPartnerContactListProps {
	dataRoomGuid: string | undefined;
	contacts: DealPartnerContact[];
	dataRoom: DataRoom;
	currentUser: CurrentUser | null;
	unlockUser: (unlockUser: UnlockUser) => void;
	removeAccess: (contact: DealPartnerContact) => void;
	sendAccountInfo: (contact: DealPartnerContact) => void;
}

export const DataRoomPartnerContactList: React.FC<DataRoomPartnerContactListProps> = ({
	dataRoomGuid,
	contacts,
	dataRoom,
	currentUser,
	unlockUser,
	removeAccess,
	sendAccountInfo
}) => {
	return (
		<>
			{(contacts == null || contacts.length == 0 || dataRoomGuid == null) && (
				<CerebroStyledBox>
					<CerebroText sx={{ marginBottom: 2 }}>There are no deal partner contacts in the data room.</CerebroText>
				</CerebroStyledBox>
			)}

			{contacts != null && contacts.length > 0 && dataRoomGuid && (
				<Grid container spacing={2} alignItems="stretch">
					{contacts.map(contact => {
						return (
							<DataRoomPartnerContactItem
                                key={contact.guid}
                                dataRoom={dataRoom}
                                contact={contact}
								currentUser={currentUser}
                                unlockUser={unlockUser}
								removeAccess={removeAccess} 
                                sendAccountInfo={sendAccountInfo}
							/>
						);
					})}
				</Grid>
			)}
		</>
	);
};
